import { Box, List, ListItem, Typography, alpha } from '@mui/material'
import { PatternOptionsObject, SeriesOptionsType } from 'highcharts'
import React from 'react'
import { BarChartMarginLeft } from '.'
import theme from 'theme'

type ReportElementFloatingLegendProps = {
  items: {
    name: string
    color: string | { pattern: { backgroundColor: string } }
  }[]
  hidden: string[]
  removeAxisPadding?: boolean
  opacity?: number
  swatchWidth?: number
  swatchHeight?: number
}

const ReportElementFloatingLegend: React.FC<
  ReportElementFloatingLegendProps
> = ({
  items,
  hidden,
  removeAxisPadding = false,
  opacity = 1,
  swatchWidth = 12,
  swatchHeight = 12,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: 'rgba(255,255,255, 0.95)',
        width: '100%',
        paddingLeft: removeAxisPadding
          ? theme.spacing(2.5)
          : `${BarChartMarginLeft}px`,
      }}
    >
      <List
        sx={{ display: 'flex', alignItems: 'flex-start', flexWrap: 'wrap' }}
      >
        {items
          .filter((item) => !hidden.includes(item.name || ''))
          .map((item, i) => {
            let color = item.color
            let background = undefined

            if (color && typeof color != 'string') {
              const pattern = color.pattern
              background = `repeating-linear-gradient(45deg, ${alpha(
                pattern.backgroundColor,
                opacity
              )}, ${alpha(
                pattern.backgroundColor,
                opacity
              )} 4px, #FFFFFF 4px, #FFFFFF 5px)`
            }
            return (
              <ListItem key={i} sx={{ width: 'auto', paddingLeft: '0px' }}>
                <Box display="flex" alignItems="center">
                  <Box
                    sx={{
                      width: `${swatchWidth}px`,
                      height: `${swatchHeight}px`,
                      backgroundColor: background
                        ? ''
                        : alpha(item.color as string, opacity),
                      background: background,
                      WebkitPrintColorAdjust: 'exact',
                      printColorAdjust: 'exact',
                      flexShrink: '0',
                    }}
                    mr={1}
                  ></Box>
                  <Typography
                    component="small"
                    sx={{ fontSize: '12px', lineHeight: '1' }}
                  >
                    {item.name}
                  </Typography>
                </Box>
              </ListItem>
            )
          })}
      </List>
    </Box>
  )
}

export default ReportElementFloatingLegend
